import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RewardsBanner, FormType } from '@/models';
import { Routes } from '@/router';
import { HomePageLinkInteractions } from '@/services/analytics/platforms/adobe-analytics/constants';

@Component({
  name: 'CmgLoyaltySignInBanner',
})
export default class CmgLoyaltySignInBanner extends Vue {
  @Prop({ type: Object })
  loyaltyBanner!: RewardsBanner;

  get isGuacMode(): boolean {
    return this.$appStore.getters.isAPIMGuacModeActive && (this.$services.config.getGuacMode()?.message || '').toLowerCase() === 'true';
  }

  onClickSignIn(event: any) {
    if (this.isGuacMode) {
      this.$router.push({ name: Routes.GuacModeSignIn });
      this.$services.ui.setModalVisibility('guacModeSignIn', true);
    } else {
      this.$services.ui.setModalVisibility('signIn', true);
    }
    this.$services.analytics.addLinkClickedEventToStore(HomePageLinkInteractions.LoyaltyBannerSignIn);
  }

  onClickCreateAccount(event: any) {
    if (event.target.className) {
      this.$services.ui.setLastSelectedElement(event.target.className);
    }

    this.$services.ui.setModalVisibility('signIn', true, { type: FormType.CreateAccount });
    this.$services.analytics.addLinkClickedEventToStore(HomePageLinkInteractions.LoyaltyBannerCreateAccount);
  }

  onClickDynamicCta() {
    window.open((this.loyaltyBanner && this.loyaltyBanner.dynamicCtaUrl) || '', '_blank');
  }
}
